<section id="main" class="bg-light">
    <div class="container">
       <h1 [innerHtml]="'RecordRequestProcessed' | translator: 'request'">
           Record Request Processed
       </h1>
       <div class="row">
       <div class="col-lg-8 mb-3 mb-lg-0">
           <button 
               class="btn btn-primary btn-strong me-2 mb-3" 
               (click)="navigateToRequestRecords()" 
               [title]="'RequestAdditionalRecords' | translator: 'request'"
               [innerHtml]="'RequestAdditionalRecords' | translator: 'request'"
           >
               Request My Records
           </button>
           <button 
               class="btn btn-primary mb-3"
               (click)="navigateToDashboard()"
               [title]="'navbar_dashboard_link' | translator: 'base'"
               [innerHtml]="'navbar_dashboard_link' | translator: 'base'"
               id="dashboardButton"
               name="dashboardButton"
           >
           Dashboard
           </button>
       </div>
           <div class="col-lg-4 order-lg-2 sidebar">
               <div><app-dashboardnews /></div>
               <app-dashboardsupport />
           </div>
       </div>
  </div>
</section>
